import { render, staticRenderFns } from "./contactDetails.vue?vue&type=template&id=47c7791f&scoped=true"
import script from "./contactDetails.vue?vue&type=script&lang=js"
export * from "./contactDetails.vue?vue&type=script&lang=js"
import style0 from "./contactDetails.vue?vue&type=style&index=0&id=47c7791f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c7791f",
  null
  
)

export default component.exports